import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { Pharmacy } from '@/api/types';

/**
 * The pharmacy's registration record (name, GSTIN, DL number, address) — not
 * to be confused with StoreSettings, which is invoice/print configuration.
 * Superadmins have none of their own; the endpoint returns null for them.
 */
export function usePharmacyProfile() {
  return useQuery({
    queryKey: ['pharmacy', 'me'],
    queryFn: () => api.get<Pharmacy | null>('/api/pharmacy/me'),
    staleTime: 60_000,
  });
}

export function useUpdatePharmacyProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: Partial<Pharmacy>) => api.put<Pharmacy>('/api/pharmacy/me', patch),
    onSuccess: (data) => queryClient.setQueryData(['pharmacy', 'me'], data),
  });
}
